import request from '../utils/request';
import { buildApiPayload } from '../utils/api';
import baseApi from './baseApi';

export function getRecommendations(params, signal) {
  return request({
    url: `/recommendationTimerCycleHistory`,
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getRecommendationsTotal(params, signal) {
  return request({
    url: `/recommendationTimerCycleHistory/total`,
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getRecommendationsAnalytic(params, signal) {
  return request({
    url: `/recommendationTimerCycleHistory/analytic`,
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function deleteRecommendation(uuid) {
  return request({
    url: `/recommendationTimerCycleHistory/${uuid}`,
    method: 'delete',
  });
}

export function exportRecommendationsReportXLS(params) {
  return request({
    url: '/recommendationTimerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function exportRecommendationsReportCSV(params) {
  return request({
    url: '/recommendationTimerCycleHistory/csv',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

const recommendationsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getRecommendationAIReport: builder.query({
      query: ({ uuid }) => ({
        url: `/ai-recommendation-report/${uuid}`,
        method: 'GET',
        keepUnusedDataFor: 3600,
      }),
    }),
  }),
});

export const {
  useLazyGetRecommendationAIReportQuery: useLazyGetRecommendationAIReport,
} = recommendationsApi;

export default recommendationsApi;
